export default {
    methods: {
        addVatText(value) {
            const locale = this.$config.site.locale;
            const vatIncluded = false;
            const showVatText = locale === 'fr' && !vatIncluded;
            const vatText = this.$t('schedule.ex-vat');

            function vat() {
                if (showVatText) {
                    return ` ${vatText}`;
                } else {
                    return '';
                }
            }

            if (value !== undefined) {
                return `${value}${vat()}`;
            }
        }
    }
};
